
(function () {
  const overlay   = document.getElementById('vs-overlay');
  const ovVideo   = document.getElementById('vs-overlay-video');
  const closeBtn  = document.getElementById('vs-close');
  const muteBtn   = document.getElementById('vs-mute');
  const nextBtn   = document.getElementById('vs-next');
  const dotsWrap  = document.getElementById('vs-dots');
  const iconSound = document.getElementById('vs-icon-sound');
  const iconMuted = document.getElementById('vs-icon-muted');

  let stories = [];
  let current = 0;
  let isMuted = true;

  function buildStories() {
    stories = Array.from(document.querySelectorAll('.vs-story-trigger')).map(btn => ({
      src:    btn.dataset.videoSrc,
      poster: btn.dataset.poster,
    }));
  }

  function buildDots() {
    dotsWrap.innerHTML = '';
    stories.forEach((_, i) => {
      const d = document.createElement('span');
      d.className = 'vs-overlay__dot' + (i === current ? ' is-active' : '');
      dotsWrap.appendChild(d);
    });
  }

  function loadVideo(index) {
    current = (index + stories.length) % stories.length;
    const s = stories[current];
    ovVideo.pause();
    ovVideo.src    = s.src;
    ovVideo.poster = s.poster;
    ovVideo.muted  = isMuted;
    ovVideo.load();
    ovVideo.play().catch(() => {});
    buildDots();
  }

  function openOverlay(index) {
    buildStories();
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    loadVideo(index);
  }

  function closeOverlay() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    ovVideo.pause();
    ovVideo.src = '';
  }

  document.addEventListener('click', e => {
    const btn = e.target.closest('.vs-story-trigger');
    if (btn) openOverlay(parseInt(btn.dataset.index, 10));
  });

  closeBtn.addEventListener('click', closeOverlay);

  nextBtn.addEventListener('click', () => loadVideo(current + 1));

  let touchStartY = 0;
  overlay.addEventListener('touchstart', e => { touchStartY = e.touches[0].clientY; }, { passive: true });
  overlay.addEventListener('touchend', e => {
    if (touchStartY - e.changedTouches[0].clientY > 60) loadVideo(current + 1);
    if (e.changedTouches[0].clientY - touchStartY > 60) loadVideo(current - 1);
  });

  muteBtn.addEventListener('click', () => {
    isMuted = !isMuted;
    ovVideo.muted = isMuted;
    iconSound.style.display = isMuted ? 'none' : '';
    iconMuted.style.display = isMuted ? '' : 'none';
  });

  overlay.addEventListener('click', e => {
    if (e.target === overlay) closeOverlay();
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeOverlay();
  });
})();
